/**
 * Toast Notification Component
 * Shows success/error messages
 */

import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

const Toast = ({ message, type = 'success', onClose, duration = 5000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const styles = {
    success: {
      bg: '#d1fae5',
      border: '#059669',
      color: '#065f46',
      icon: CheckCircle
    },
    error: {
      bg: '#fee2e2',
      border: '#dc2626',
      color: '#991b1b',
      icon: XCircle
    }
  };

  const style = styles[type] || styles.success;
  const Icon = style.icon;

  return (
    <div style={{
      position: 'fixed',
      bottom: '2rem',
      right: '2rem',
      zIndex: 999999,
      minWidth: '320px',
      maxWidth: '450px',
      background: style.bg,
      border: `2px solid ${style.border}`,
      borderRadius: '0.75rem',
      padding: '1rem 1.5rem',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '1rem',
      animation: 'slideInRight 0.3s ease-out',
      pointerEvents: 'auto'
    }}>
      <Icon size={24} color={style.border} style={{ flexShrink: 0, marginTop: '0.125rem' }} />
      <p style={{
        flex: 1,
        color: style.color,
        fontSize: '0.9375rem',
        fontWeight: '600',
        margin: 0,
        lineHeight: '1.5',
        wordBreak: 'break-word'
      }}>
        {message}
      </p>
      <button
        onClick={onClose}
        style={{
          padding: '0.25rem',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          marginTop: '0.125rem'
        }}
      >
        <X size={18} color={style.color} />
      </button>
      <style>{`
        @keyframes slideInRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Toast;
